<template>
    <div id="container">
        <v-container>
            <v-layout>
                <v-flex xs12 pa-5>
                    <h1 class="mb-3">Impressum</h1>
                    <h3>Angaben gemäß § 5 TMG:</h3>
                    <p><strong>Comsoltec GmbH</strong><br />
                    Breite Str.5<br />
                    01796 Pirna</p>

                    <p>Handelsregisternr: HRB 27250<br />
                    Handelsregister: Dresden</p>

                    <p>Geschäftsführer:<br />
                    Klaus-Peter Reidl</p>

                    <p>Kontakt:<br />
                    E-Mail: <a href="mailto:shop@easy-phones.de">mailto:shop@easy-phones.de</a></p>

                    <p>Umsatzsteuer-Identifikationsnummer gemäß §27 a Umsatzsteuergesetz:<br />
                    20415308699</p>

                    <h3>Hinweis auf EU-Streitschlichtung</h3>
                    <p>Die Europäische Kommission stellt eine Plattform zur Online-Streitbeilegung (OS) bereit: http://ec.europa.eu/consumers/odr
                    Unsere E-Mail-Adresse finden sie oben im Impressum.</p>

                    <h3>Auskunft, Löschung, Sperrung</h3>
                    <p>Sie haben jederzeit das Recht auf unentgeltliche Auskunft über Ihre gespeicherten personenbezogenen Daten, deren Herkunft und Empfänger und den Zweck der Datenverarbeitung sowie ein Recht auf Berichtigung, Sperrung oder Löschung dieser Daten. Hierzu sowie zu weiteren Fragen zum Thema personenbezogene Daten können Sie sich jederzeit unter der im Impressum angegebenen Adresse an uns wenden.</p>

                    <h3>Cookies</h3>
                    <p>Die Internetseiten verwenden teilweise so genannte Cookies. Cookies richten auf Ihrem Rechner keinen Schaden an und enthalten keine Viren. Cookies dienen dazu, unser Angebot nutzerfreundlicher, effektiver und sicherer zu machen. Cookies sind kleine Textdateien, die auf Ihrem Rechner abgelegt werden und die Ihr Browser speichert.</p>

                    <p>Die meisten der von uns verwendeten Cookies sind so genannte „Session-Cookies“. Sie werden nach Ende Ihres Besuchs automatisch gelöscht. Andere Cookies bleiben auf Ihrem Endgerät gespeichert, bis Sie diese löschen. Diese Cookies ermöglichen es uns, Ihren Browser beim nächsten Besuch wiederzuerkennen.</p>

                    <p>Sie können Ihren Browser so einstellen, dass Sie über das Setzen von Cookies informiert werden und Cookies nur im Einzelfall erlauben, die Annahme von Cookies für bestimmte Fälle oder generell ausschließen sowie das automatische Löschen der Cookies beim Schließen des Browser aktivieren. Bei der Deaktivierung von Cookies kann die Funktionalität dieser Website eingeschränkt sein.</p>

                    <h3>Server-Log-Files</h3>
                    <p>Der Provider der Seiten erhebt und speichert automatisch Informationen in so genannten Server-Log Files, die Ihr Browser automatisch an uns übermittelt.</p>

                    Dies sind:

                    <p>Browsertyp/ Browserversion
                    verwendetes Betriebssystem
                    Referrer URL
                    Hostname des zugreifenden Rechners
                    Uhrzeit der Serveranfrage</p>

                    <p>Diese Daten sind nicht bestimmten Personen zuordenbar. Eine Zusammenführung dieser Daten mit anderen Datenquellen wird nicht vorgenommen. Wir behalten uns vor, diese Daten nachträglich zu prüfen, wenn uns konkrete Anhaltspunkte für eine rechtswidrige Nutzung bekannt werden.</p>

                    <h3>Kontaktformular</h3>
                    <p>Wenn Sie uns per Kontaktformular Anfragen zukommen lassen, werden Ihre Angaben aus dem Anfrageformular inklusive der von Ihnen dort angegebenen Kontaktdaten zwecks Bearbeitung der Anfrage und für den Fall von Anschlussfragen bei uns gespeichert. Diese Daten geben wir nicht ohne Ihre Einwilligung weiter.</p>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>

<script>
    export default {
      mounted() {
        this.$vuetify.goTo(0)
      }
    }
</script>